module.exports = __webpack_public_path__ + "static/img/icon_follow.95cbfc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon_follow.png
// module id = PNch
// module chunks = 28